module.exports = __webpack_public_path__ + "2ae1c9b6ff6eec4d6914b0526650a633.png";